/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const coupon = {
    //获取所有发布可用的优惠券信息
    getAllCouponListInfo(params) {
        return axios.post('/goods/mobileCoupon/getAllCouponListInfo', qs.stringify(params));
    },
    //用户领取优惠券信息
    receiveCoupon(params) {
        return axios.post('/goods/mobileCoupon/receiveCoupon', qs.stringify(params));
    },
    //获取用户已领取优惠券列表信息
    getUserReceiveCouponInfo(params) {
        return axios.post('/goods/mobileCoupon/getUserReceiveCouponInfo', qs.stringify(params));
    },
    //根据优惠券id获取优惠券详情信息
    getCouponDetailById(params) {
        return axios.post('/goods/mobileCoupon/getCouponDetailById', qs.stringify(params));
    },
    //新人大礼包
    grantCouponForNewComers(params) {
        return axios.post('/goods/mobileCoupon/grantCouponForNewComers', qs.stringify(params));
    }
}

export default coupon;


// WEBPACK FOOTER //
// ./src/request/api/coupon/coupon.js